
import 'core-js/fn/string/starts-with';

import 'core-js/es6/promise';
import 'core-js/es6/array';



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/polyfill.ts